import React from 'react';
import { cn, ui } from '../../utils';

const CommonEmojiPicker = React.lazy(() => import('../Common/EmojiPicker').then((m) => ({ default: m.EmojiPicker })));

interface EmojiPickerProps {
  disabled?: boolean;
  onSelect: (emoji: string) => void;
}

export function EmojiPicker({ disabled, onSelect }: EmojiPickerProps) {
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div className="relative shrink-0">
      <button
        type="button"
        onClick={() => setIsOpen((open) => !open)}
        disabled={disabled}
        aria-label="Open emoji picker"
        title="Open emoji picker"
        className={cn(
          ui.button.icon,
          'h-10 min-w-10',
          isOpen && 'bg-background text-foreground',
          disabled && 'cursor-not-allowed opacity-50',
        )}
      >
        <span className="text-lg leading-none">😊</span>
      </button>

      {isOpen ? (
        <React.Suspense fallback={<div className="absolute bottom-full right-0 mb-2 rounded-xl border border-border bg-card px-3 py-2 text-xs text-muted-foreground shadow-xl">Loading...</div>}>
          <CommonEmojiPicker
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            onSelect={onSelect}
            panelClassName="w-[24rem]"
            placement="top-right"
          />
        </React.Suspense>
      ) : null}
    </div>
  );
}

export default EmojiPicker;
